export default __webpack_public_path__ + "static/media/ao.c930a5b0.svg";